import React, { useEffect, useState } from 'react';
import { IntroSection } from './components/IntroSection';
import { QuizSection } from './components/QuizSection';
import { LoadingSection } from './components/LoadingSection';
import { ResultSection } from './components/ResultSection';
import { OfferSection } from './components/OfferSection';
import { Footer } from './components/Footer';
import { initMetaPixel } from './lib/metaPixel';
type Stage = 'intro' | 'quiz' | 'loading' | 'result';
export function App() {
  const [stage, setStage] = useState<Stage>('intro');
  const [score, setScore] = useState<number>(0);
  // Initialize Meta Pixel + fire PageView on mount
  useEffect(() => {
    initMetaPixel();
  }, []);
  // Scroll to top on stage change
  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  }, [stage]);
  const handleStartQuiz = () => {
    setStage('quiz');
  };
  const handleQuizComplete = (finalScore: number) => {
    setScore(finalScore);
    setStage('loading');
  };
  const handleLoadingComplete = () => {
    setStage('result');
  };
  return <div className="min-h-screen bg-white font-sans text-gray-900 selection:bg-brand-red selection:text-white" data-id="element-0">
      {stage === 'intro' && <IntroSection onStart={handleStartQuiz} data-id="element-1" />}

      {stage === 'quiz' && <QuizSection onComplete={handleQuizComplete} data-id="element-2" />}

      {stage === 'loading' && <LoadingSection onComplete={handleLoadingComplete} data-id="element-3" />}

      {stage === 'result' && <>
          <ResultSection score={score} data-id="element-4" />
          <OfferSection data-id="element-5" />
        </>}

      <Footer data-id="element-6" />
    </div>;
}